import React from "react";
import "./WordBreaker.css";

export default function WordBreaker({ children }) {
  return <div className="word-breaker">{children}</div>;
}
